import React, { useState, useEffect } from "react";
import toastr from "toastr";
import { authFetch } from "../utils/authFetch";

function MerchantBank() {
  const [bankForm, setBankForm] = useState({
    user_id: "",
    account_holder_name: "",
    account_number: "",
    ifsc_code: "",
    bank_name: "",
    account_type: "",
    upi_id: "",
    pan_number: "",
    gst_number: "",
    // charges:"",
    // gst:"",
    verified_status: "pending",
    added_by: "system",
  });

  const [banks, setBanks] = useState([]);
  const [users, setUsers] = useState([]); // ✅ user list state
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);

  const [showSettlementModal, setShowSettlementModal] = useState(false);
  const [settlementForm, setSettlementForm] = useState({
    payment_mode: "",
    bank_id: "",
    amount: "",
    gst_percent: "",
    total_amount: 0,
  });

  const showToast = (message, type = "success") => {
    toastr.options = {
      closeButton: true,
      progressBar: true,
      positionClass: "toast-top-right",
      timeOut: "3000",
    };
    if (type === "success") toastr.success(message);
    else if (type === "info") toastr.info(message);
    else toastr.error(message);
  };

  // ✅ Fetch all users for dropdown
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await authFetch("/api/v1/member/userlist");
        const data = await res.json();
        setUsers(data || []);
      } catch (error) {
        console.error("Error fetching user list:", error);
      }
    };
    fetchUsers();
  }, []);

  // ✅ Fetch all bank records
  const fetchBanks = async () => {
    try {
      const res = await authFetch("/api/v1/merchant_bank/list");
      const data = await res.json();
      setBanks(Array.isArray(data) ? data : []);
    } catch (err) {
      showToast("Failed to fetch Merchant Banks", "error");
    }
  };

  useEffect(() => {
    fetchBanks();
  }, []);

  // ✅ Create or Update
  const handleCreateOrUpdate = async () => {
    if (!bankForm.account_holder_name.trim()) {
      showToast("Account holder name is required", "error");
      return;
    }
    if (!bankForm.user_id) {
      showToast("Please select a user", "error");
      return;
    }

    setLoading(true);
    const url = editingId
      ? `/api/v1/merchant_bank/update/${editingId}`
      : "/api/v1/merchant_bank/create";
    const method = editingId ? "PUT" : "POST";

    try {
      const res = await authFetch(url, {
        method,
        body: JSON.stringify(bankForm),
      });
      const data = await res.json();
      if (!res.ok && data.detail) throw new Error(data.detail);

      showToast(editingId ? "Bank updated" : "Bank added", "success");

      setBankForm({
        user_id: "",
        account_holder_name: "",
        account_number: "",
        ifsc_code: "",
        bank_name: "",
        account_type: "",
        upi_id: "",
        pan_number: "",
        gst_number: "",
        // charges: "",
        // gst: "",
        verified_status: "pending",
        added_by: "system",
      });
      setEditingId(null);
      fetchBanks();
      document.querySelector("#bankModal .btn-close").click();
    } catch (err) {
      showToast(err.message || "Error saving data", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (bank) => {
    setBankForm({ ...bank });
    setEditingId(bank.id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;
    try {
      const res = await authFetch(`/api/v1/merchant_bank/delete/${id}`, {
        method: "DELETE",
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Delete failed");

      showToast("Merchant Bank deleted", "success");
      fetchBanks();
    } catch (err) {
      showToast(err.message, "error");
    }
  };

  const handleChange = (e) => {
    setBankForm({ ...bankForm, [e.target.name]: e.target.value });
  };

  const handleSettlementChange = (e) => {
    const { name, value } = e.target;
    const updated = { ...settlementForm, [name]: value };

    if (name === "amount" || name === "gst_percent") {
      const amt = parseFloat(updated.amount || 0);
      const gst = parseFloat(updated.gst_percent || 0);
      updated.total_amount = amt + (amt * gst) / 100;
    }
    setSettlementForm(updated);
  };

  const handleSettlementSubmit = async () => {
    if (!settlementForm.payment_mode || !settlementForm.bank_id || !settlementForm.amount) {
      showToast("All fields are required", "error");
      return;
    }

    try {
      const res = await authFetch("/api/v1/merchant_bank/settlement", {
        method: "POST",
        body: JSON.stringify(settlementForm),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Settlement failed");
      showToast("Settlement processed successfully", "success");
      setSettlementForm({
        payment_mode: "",
        bank_id: "",
        amount: "",
        gst_percent: "",
        total_amount: 0,
      });
      setShowSettlementModal(false);
    } catch (err) {
      showToast(err.message, "error");
    }
  };

   const getUserName = (userId) => {
    const user = users.find((u) => u.id === userId);
    return user ? `${user.name} (${user.mobile})` : userId;
  };

  return (
    <div className="page-wrapper">
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="card">
            <div className="card-body">
              <div className="card-title d-flex justify-content-between align-items-center">
                <h4 className="mb-0">Merchant Bank Manager</h4>
                <button
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#bankModal"
                  onClick={() => {
                    setBankForm({
                      user_id: "",
                      account_holder_name: "",
                      account_number: "",
                      ifsc_code: "",
                      bank_name: "",
                      account_type: "",
                      upi_id: "",
                      pan_number: "",
                      gst_number: "",
                    //   charges: "",
                    //   gst: "",
                      verified_status: "pending",
                      added_by: "system",
                    });
                    setEditingId(null);
                  }}
                >
                  Add
                </button>
              </div>

              {/* Modal */}
              <div className="modal fade" id="bankModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">
                        {editingId ? "Edit Merchant Bank" : "Add Merchant Bank"}
                      </h5>
                      <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div className="modal-body">
                      <label className="form-label">Select User</label>
                      <select
                        name="user_id"
                        value={bankForm.user_id}
                        onChange={handleChange}
                        className="form-control mb-2"
                      >
                        <option value="">-- Select User --</option>
                        {users.length > 0 ? (
                          users.map((user) => (
                            <option key={user.id} value={user.id}>
                              {user.name} ({user.mobile})
                            </option>
                          ))
                        ) : (
                          <option disabled>Loading users...</option>
                        )}
                      </select>

                      <label className="form-label">Account Holder Name</label>
                      <input
                        name="account_holder_name"
                        className="form-control mb-2"
                        placeholder="Account Holder Name"
                        value={bankForm.account_holder_name}
                        onChange={handleChange}
                      />

                      <label className="form-label">Account Number</label>
                      <input
                        name="account_number"
                        className="form-control mb-2"
                        placeholder="Account Number"
                        value={bankForm.account_number}
                        onChange={handleChange}
                      />

                      <label className="form-label">IFSC Code</label>
                      <input
                        name="ifsc_code"
                        className="form-control mb-2"
                        placeholder="IFSC Code"
                        value={bankForm.ifsc_code}
                        onChange={handleChange}
                      />

                      <label className="form-label">Bank Name</label>
                      <input
                        name="bank_name"
                        className="form-control mb-2"
                        placeholder="Bank Name"
                        value={bankForm.bank_name}
                        onChange={handleChange}
                      />

                      <label className="form-label">Account Type</label>
                      <select
                        name="account_type"
                        className="form-control mb-2"
                        value={bankForm.account_type}
                        onChange={handleChange}
                      >
                        <option value="">Select Type</option>
                        <option value="Savings">Savings</option>
                        <option value="Current">Current</option>
                      </select>

                      <label className="form-label">UPI ID</label>
                      <input
                        name="upi_id"
                        className="form-control mb-2"
                        placeholder="UPI ID"
                        value={bankForm.upi_id}
                        onChange={handleChange}
                      />

                      <label className="form-label">PAN Number</label>
                      <input
                        name="pan_number"
                        className="form-control mb-2"
                        placeholder="PAN Number"
                        value={bankForm.pan_number}
                        onChange={handleChange}
                      />

                      <label className="form-label">GST Number</label>
                      <input
                        name="gst_number"
                        className="form-control mb-2"
                        placeholder="GST Number"
                        value={bankForm.gst_number}
                        onChange={handleChange}
                      />

                      {/* <label className="form-label">Charges (₹)</label>
                      <input
                        name="charges"
                        type="number"
                        className="form-control mb-2"
                        placeholder="Enter Charges"
                        value={bankForm.charges}
                        onChange={handleChange}
                      />

                      <label className="form-label">GST (%)</label>
                      <input
                        name="gst"
                        type="number"
                        className="form-control mb-2"
                        placeholder="Enter GST"
                        value={bankForm.gst}
                        onChange={handleChange}
                      /> */}

                      <label className="form-label">Verified Status</label>
                      <select
                        name="verified_status"
                        className="form-control"
                        value={bankForm.verified_status}
                        onChange={handleChange}
                      >
                        <option value="pending">Pending</option>
                        <option value="verified">Verified</option>
                        <option value="rejected">Rejected</option>
                      </select>
                    </div>
                    <div className="modal-footer">
                      <button className="btn btn-secondary" data-bs-dismiss="modal">
                        Close
                      </button>
                      <button className="btn btn-primary" onClick={handleCreateOrUpdate} disabled={loading}>
                        {loading ? "Saving..." : editingId ? "Update" : "Save"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Table */}
              <hr />
              <div className="table-responsive">
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>User</th>
                      <th>Account Holder</th>
                      <th>Bank</th>
                      <th>Account No</th>
                      <th>IFSC</th>
                      <th>Type</th>
                      <th>UPI</th>
                      <th>PAN</th>
                      <th>GST</th>
                      {/* <th>Charges</th>
                      <th>Gst (%)</th> */}
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {banks.length === 0 ? (
                      <tr>
                        <td colSpan="12" className="text-center">
                          No Merchant Bank records found
                        </td>
                      </tr>
                    ) : (
                      banks.map((bank, i) => (
                        <tr key={bank.id}>
                          <td>{i + 1}</td>
                          {/* <td>{bank.user_id}</td> */}
                          <td>{getUserName(bank.user_id)}</td>
                          <td>{bank.account_holder_name}</td>
                          <td>{bank.bank_name}</td>
                          <td>{bank.account_number}</td>
                          <td>{bank.ifsc_code}</td>
                          <td>{bank.account_type}</td>
                          <td>{bank.upi_id}</td>
                          <td>{bank.pan_number}</td>
                          <td>{bank.gst_number}</td>
                          {/* <td>{bank.charges}</td>
                          <td>{bank.gst}</td> */}
                          <td>{bank.verified_status}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-info me-2"
                              data-bs-toggle="modal"
                              data-bs-target="#bankModal"
                              onClick={() => handleEdit(bank)}
                            >
                              <span className="bx bx-edit"></span>
                            </button>
                            {/* <button
                              className="btn btn-sm btn-danger"
                              onClick={() => handleDelete(bank.id)}
                            >
                              <span className="bx bx-trash"></span>
                            </button> */}
                            <button
                                className="btn btn-success"
                                onClick={() => setShowSettlementModal(true)}
                            >
                                Settlement
                            </button>

                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {showSettlementModal && (
                <div
                  className="modal fade show"
                  style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
                >
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Settlement</h5>
                        <button
                          className="btn-close"
                          onClick={() => setShowSettlementModal(false)}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <label>Payment Mode</label>
                        <select
                          name="payment_mode"
                          className="form-control mb-2"
                          value={settlementForm.payment_mode}
                          onChange={handleSettlementChange}
                        >
                          <option value="">Select Mode</option>
                          <option value="NEFT">NEFT</option>
                          <option value="UPI">UPI</option>
                          <option value="IMPS">IMPS</option>
                          <option value="RTGS">RTGS</option>
                          <option value="Wallet">Wallet</option>
                        </select>

                        <label>Select Bank</label>
                        <select
                          name="bank_id"
                          className="form-control mb-2"
                          value={settlementForm.bank_id}
                          onChange={handleSettlementChange}
                        >
                          <option value="">Select Bank</option>
                          {banks.map((b) => (
                            <option key={b.id} value={b.id}>
                              {b.bank_name} ({b.account_number})
                            </option>
                          ))}
                        </select>

                        <label>Amount</label>
                        <input
                          type="number"
                          name="amount"
                          className="form-control mb-2"
                          value={settlementForm.amount}
                          onChange={handleSettlementChange}
                        />

                        <label>GST (%)</label>
                        <input
                          type="number"
                          name="gst_percent"
                          className="form-control mb-2"
                          value={settlementForm.gst_percent}
                          onChange={handleSettlementChange}
                        />

                        <div className="mt-2">
                          <strong>Total: ₹{settlementForm.total_amount.toFixed(2)}</strong>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          className="btn btn-secondary"
                          onClick={() => setShowSettlementModal(false)}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn btn-success"
                          onClick={handleSettlementSubmit}
                        >
                          Submit Settlement
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}


            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MerchantBank;
